import { z } from 'zod';
/**
 * Data states according to development paper §13.1 and ADR-003.
 * Availability, origin and verification status are three independent dimensions –
 * they do not form a linear sequence of stages.
 */
export const Availability = z.enum(['not_collected', 'unknown', 'not_applicable', 'present']);
export const Origin = z.enum(['stated', 'imported', 'derived', 'third_party']);
export const Verification = z.enum(['open', 'evidenced', 'verified', 'contradictory']);
export const availabilityLabel = {
    not_collected: 'nicht erhoben',
    unknown: 'unbekannt',
    not_applicable: 'nicht einschlägig',
    present: 'vorhanden',
};
export const originLabel = {
    stated: 'angegeben',
    imported: 'importiert',
    derived: 'abgeleitet',
    third_party: 'Drittquelle',
};
export const verificationLabel = {
    open: 'offen',
    evidenced: 'nachgewiesen',
    verified: 'geprüft',
    contradictory: 'widersprüchlich',
};
//# sourceMappingURL=data-states.js.map